import type { CmmdRuntimeThreadReplica, ModelSelection } from "@cmmd-forge/contracts";

import { useComposerUsageNotice } from "./composerUsageNotice";

export function useRemoteComposerUsageNotice(input: {
  readonly threadId: string;
  readonly modelSelection: ModelSelection;
  readonly replica: CmmdRuntimeThreadReplica | null;
  readonly pendingInputId: string | null;
}) {
  // A replica does not publish approval or question IDs. The remote owner can
  // clear only for the staged local submission, then normal ownership uses the
  // response IDs once the connection becomes live.
  return useComposerUsageNotice({
    threadId: input.threadId,
    modelSelection: input.modelSelection,
    rateLimitStatus: undefined,
    latestTurnId: latestRemoteTurnId(input.replica),
    pendingInputId: input.pendingInputId,
  });
}

function latestRemoteTurnId(replica: CmmdRuntimeThreadReplica | null): string | null {
  return replica?.events.findLast((event) => event.turnId !== null)?.turnId ?? null;
}
